
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("a9FiN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $764ac86749ceb57d$var$_jquery = $764ac86749ceb57d$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $764ac86749ceb57d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $764ac86749ceb57d$var$init = module.exports.init = function init() {
    var attempts = 0;
    // Search field --------------------------------------------------------------
    /*$(".search-trigger").click(function () {
  		return $(this).toggleClass("search-trigger-transform"), $(this).next(".searchbox").fadeToggle("normal"), $("#q").focus(),	!1;
  	});*/ // Debounce function to suppress ajax calls on every keypress
    Function.prototype.debounce = function(wait) {
        var timeout;
        var debouncedFunc = this;
        return function() {
            var context = this;
            function later(args) {
                timeout = null;
                debouncedFunc.apply(context, args);
            }
            clearTimeout(timeout);
            timeout = setTimeout(later, wait, arguments);
        };
    };
    // Remove existing suggestions and shrink search field
    function resetSuggestions() {
        (0, $764ac86749ceb57d$var$_jquery["default"])(".searchbox .pinnedSearch").slideUp(function() {
            (0, $764ac86749ceb57d$var$_jquery["default"])(".searchbox").removeClass("large");
            (0, $764ac86749ceb57d$var$_jquery["default"])(".searchbox .pinnedSearch").remove();
        });
    }
    // Ajax pinned search ajax search method
    function search(searchTerm) {
        var params = new URLSearchParams({
            searchTerm: searchTerm,
            categoryParent: pinnedSearchParent
        });
        fetch("".concat(currentPageUrl, "?type=105736&cmd=pinnedSearch&").concat(params), {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            var searchbox = (0, $764ac86749ceb57d$var$_jquery["default"])(".searchbox");
            if (data.results !== undefined && data.results.length > 0) {
                var buildResults = function buildResults(data) {
                    var html = "";
                    for(var i = 0; i < data.results.length; i++){
                        html += '<div class="result"><a href="' + data.results[i]._url + '" class="result-box">';
                        if (data.results[i]._image) html += '<div class="image-box"><img alt="" src="' + data.results[i]._image + '"/></div>';
                        html += '<div class="text-box"><div class="title lead"><strong>' + data.results[i].title + "</strong></div>" + '<div class="description lead">' + data.results[i].description + "</div>";
                        if (data.results[i]._keywords) {
                            html += '<div class="keywords">';
                            for(var j = 0; j < data.results[i]._keywords.length; j++){
                                if (j > 0 && j < data.results[i]._keywords.length) html += ", ";
                                html += data.results[i]._keywords[j].title;
                            }
                            html += "</div>";
                        }
                        html += "</div></a></div>";
                    }
                    return html;
                };
                var allResults = function allResults() {
                    return '<div class="link_results"><a href="javascript:void(0);" onclick="document.getElementById(\'searchbox\').submit();">Alle Suchergebnisse &gt;</a></div>';
                };
                // Enlarge search box if there are results
                if (!searchbox.hasClass("large")) searchbox.addClass("large");
                if (searchbox.find(".pinnedSearch").length > 0) searchbox.find(".pinnedSearch .result").slideUp(function() {
                    searchbox.find(".pinnedSearch .result").remove();
                    var html = buildResults(data);
                    searchbox.find(".pinnedSearch").prepend(html);
                    searchbox.find(".pinnedSearch .result").slideDown();
                });
                else {
                    // Clear existing results
                    searchbox.find(".pinnedSearch").remove();
                    // Build html for suggestions
                    var html = '<div class="pinnedSearch">';
                    html += buildResults(data);
                    html += allResults();
                    html += "</div>";
                    // Append suggestions to searchbox
                    (0, $764ac86749ceb57d$var$_jquery["default"])(".searchbox").append(html);
                    searchbox.find(".pinnedSearch .result").show();
                    setTimeout(function() {
                        (0, $764ac86749ceb57d$var$_jquery["default"])(".searchbox .pinnedSearch").slideDown();
                    }, 300);
                }
            } else // Clear suggestions if ajax response has no results
            resetSuggestions();
        })["catch"](function(error) {
            console.error("Fehler beim Abrufen der Daten:", error);
            resetSuggestions();
        });
    }
    var _whenComplete = function whenComplete() {
        if (++attempts > 30) return;
        if (document.readyState === "complete") (0, $764ac86749ceb57d$var$_jquery["default"])(".searchbox input#q").keyup((function(e) {
            var searchTerm = (0, $764ac86749ceb57d$var$_jquery["default"])(this).val();
            // Clear suggests and minimize search field or search
            if (searchTerm.length === 0) resetSuggestions();
            else if (searchTerm.length > 2) search(searchTerm);
        }).debounce(600));
        else setTimeout(function() {
            return _whenComplete();
        }, 400);
    };
    _whenComplete();
};

});


//# sourceMappingURL=searchbox.module.a23a1ddc.js.map
